import axios from "axios";
import { constructSearchObj } from "../../utils/utils";
import {
  RESTAURANTS_CLEAR_EMAIL_AND_PHONE_TYPES_DATA,
  RESTAURANTS_CLEAR_ENTITIES,
  RESTAURANTS_CLEAR_PAGINATION_INFO,
  RESTAURANTS_EDIT_ENTITY,
  RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES,
  RESTAURANTS_FETCH_ENTITIES,
  RESTAURANTS_FETCH_ENTITY,
  RESTAURANTS_SET_PAGE,
  RESTAURANTS_SET_ROWS_PER_PAGE,
  SELECTED_RESTAURANTS_LIST
} from "../action-types/restaurant-types";
import { axiosAction } from "../../utils/axiosAction";
import { ATTRIBUTES_FETCH, RESTAURANT_ATTRIBUTE_UPDATE } from "../action-types/attributes-types";
import { SERVICES_FETCH, SERVICES_UPDATE } from "../action-types/services-types";

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_RESTAURANTS}`;

export const clearEntities = () => ({
  type: RESTAURANTS_CLEAR_ENTITIES,
});

export const setRowsPerPageAction = payload => ({
  type: RESTAURANTS_SET_ROWS_PER_PAGE,
  payload,
});

export const setPageAction = payload => ({
  type: RESTAURANTS_SET_PAGE,
  payload,
});

export const clearPaginationInfo = () => ({
  type: RESTAURANTS_CLEAR_PAGINATION_INFO,
});

const getEmailAndPhoneTypesRequest = () => ({
  type: RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES.REQUEST,
});

const getEmailAndPhoneTypesSuccess = payload => ({
  type: RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES.SUCCESS,
  payload,
});

const getEmailAndPhoneTypesRejected = () => ({
  type: RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES.REJECTED,
});

export const clearEmailAndPhoneTypesData = () => ({
  type: RESTAURANTS_CLEAR_EMAIL_AND_PHONE_TYPES_DATA,
});

export const getEntities = searchObj => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT}${constructSearchObj(searchObj)}`,
    RESTAURANTS_FETCH_ENTITIES,
    dispatch,
  );
};

export const getEntity = id => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT}/${id}`,
    RESTAURANTS_FETCH_ENTITY,
    dispatch,
  );
};

export const getEmailAndPhoneTypes = brand => async dispatch => {
  try {
    dispatch(getEmailAndPhoneTypesRequest());

    const endPoint = ENDPOINT.replace('/restaurants', '');
    const getPhoneTypes = axios.get(`${endPoint}/phone-types?brand=${brand}`);
    const getEmailTypes = axios.get(`${endPoint}/email-types?brand=${brand}`);
    const result: any = await Promise.all([getPhoneTypes, getEmailTypes]);
    const phonesAndEmails = { phones: result[0].data, emails: result[1].data };

    dispatch(getEmailAndPhoneTypesSuccess(phonesAndEmails));

    return phonesAndEmails;
  } catch (error) {
    dispatch(getEmailAndPhoneTypesRejected());
    return error?.response;
  }
};

export const editEntity = editObject => async dispatch => {
  const restaurantId = editObject.restaurantId;
  let emailInputs = [...editObject.emails];
  const phones = [...editObject.phones];
  let emails = emailInputs.map((e) => {
    return {
      id: e.id,
      operation: e.operation,
      type: e.type,
      value: e.value
    };
  });
  editObject.kioskType = parseInt(editObject.kioskType) || 1;
  delete editObject.emailInputs;
  delete editObject.phones;
  delete editObject.restaurantId;
  const resultGeneral = axiosAction.patch(
    `${ENDPOINT}/${restaurantId}`,
    RESTAURANTS_EDIT_ENTITY,
    dispatch,
    editObject,
  );
  if(editObject['changeemails']){
    await axios.put(`${ENDPOINT}/${restaurantId}/emails`, {
      emails,
    });
  }
  if(editObject['changephones']){
    await axios.put(`${ENDPOINT}/${restaurantId}/phones`, {
      phones,
    });
  }
  return resultGeneral;
};

export const getRestaurantAttributes = restaurantId => async dispatch => {
  const endpoint = `${ENDPOINT}/${restaurantId}/attributes`;

  return axiosAction.get(`${endpoint}`, ATTRIBUTES_FETCH, dispatch);
};

export const getRestaurantServices = restaurantId => async dispatch => {
  const endpoint = `${ENDPOINT}/${restaurantId}/services`;

  return axiosAction.get(`${endpoint}`, SERVICES_FETCH, dispatch);
};

export const patchRestaurantAttributes =
  (restaurantId, payload) => async dispatch => {
    const endpoint = `${ENDPOINT}/${restaurantId}/attributes`;

    return axiosAction.patch(`${endpoint}`, SERVICES_UPDATE, dispatch, payload);
  };

export const patchRestaurantServices =
  (restaurantId, payload) => async dispatch => {
    const endpoint = `${ENDPOINT}/${restaurantId}/services`;
    return axiosAction.patch(
      `${endpoint}`,
      RESTAURANT_ATTRIBUTE_UPDATE,
      dispatch,
      payload,
    );
  };

export const setSelectedRestaurantList = (payload) => ({
  type: SELECTED_RESTAURANTS_LIST,
  payload
})

export const setRestaurantService = (services) => ({
  type: SERVICES_FETCH.SUCCESS,
  payload: {
    data: services
  }
})